import React from 'react';
import _ from 'lodash';

import { useFieldBulletinBoardDetail } from '../../services/fieldBulletinBoard/FieldBulletinBoardDetailContext';

import FieldBulletinBoardsService from '../../services/fieldBulletinBoard/FieldBulletinBoardsService';
import { DATE_TIME_FORMAT, IMPORTANCE_TYPE } from '../../utilities/constants';
import { messageUtility } from '../../utilities/messageUtility';

import { Information } from '../modals/common';

import Tooltip from '@mui/material/Tooltip';
import { Button } from '@bld/bld-libs/components';
import ErrorIcon from '@mui/icons-material/Error';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import UploadIcon from '../../images/icon/icon--download-5.svg';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';

import Styles from '../../styles/componentStyle/fieldBulletinBoard/FieldBulletinBoardDetail.scss';

export function FieldBulletinBoardDetailForPartner() {
  const {
    getDetailInfo,
    handleDownload,
    getModalDisplayInfo,
    getErrorDialogProperty,
    closeConfirmDialog,
  } = useFieldBulletinBoardDetail();

  const detail = getDetailInfo();

  /**
   * エラーダイアログ用のタイトル
   * */
  const ErrorDialogTitle = () => {
    return (
      <React.Fragment>
        <ReportProblemOutlinedIcon
          sx={{ fill: '#d32f2f', verticalAlign: 'middle' }}
        />
        {getErrorDialogProperty().title}
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      <div className={`${Styles.detailPartner}`}>
        <div className='partner-detail'>
          <div className='partner-detail-head'>
            <h2 className='partner-detail-head__title'>
              {detail.importance_type === IMPORTANCE_TYPE.CHECK && (
                <ErrorIcon className='partner-detail-head__importance-icon' />
              )}
              {detail.title}
            </h2>
            <span className='partner-detail-head__publish-date'>
              {messageUtility.getMessage('I-000-166-27')}
              {FieldBulletinBoardsService.convertDate(
                detail.publication_start_at,
                DATE_TIME_FORMAT.weekdaySlashDateFormat
              )}
            </span>
          </div>
          <div className='partner-detail-contents'>
            <div className='partner-detail-contents__txt'>
              {detail.contents}
            </div>
            <div className='partner-detail-contents__files'>
              <div className='file-count'>
                <AttachFileIcon className='clip-icon' />
                {`${messageUtility.getMessage('I-000-165-30')} (${_.size(
                  detail.documents
                )})`}
              </div>
              {/* ダウンロードファイル */}
              {!_.isEmpty(detail.documents) &&
                _.map(detail.documents, (info, key) => {
                  return (
                    <div key={key} className='files__name'>
                      <Tooltip
                        title={`${info.file_name}`}
                        placement='bottom'
                        arrow
                      >
                        <div className='files__txt'>{info.file_name}</div>
                      </Tooltip>
                      <Button
                        color='primary'
                        variant='contained'
                        sx={{ minWidth: '10%', height: 30 }}
                        onClick={() => handleDownload(info.id)}
                      >
                        <img src={UploadIcon} className='files__icon' />
                      </Button>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
      {/* エラーダイアログ */}
      <Information
        visible={
          _.has(getModalDisplayInfo(), 'error') && getModalDisplayInfo().error
        }
        title={<ErrorDialogTitle />}
        message={getErrorDialogProperty().message}
        onClose={() => closeConfirmDialog()}
        buttonText={messageUtility.getMessage('I-000-017')}
      />
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/fieldBulletinBoard/FieldBulletinBoardDetailForPartner.jsx